import { useEffect } from "react";
import { store, useAppDispatch } from "../../redux/store";
import { setRenderHash } from "../../redux/reducers/ui/uiReducer";
import {
  changeShowModal,
  setServerStatus,
  setWsConnected,
} from "../../redux/reducers/app/appReducer";
import { MOCK_ORGANIZATION_ID } from "../../utils/constants";
import WebSocketService from "../../services/WebSocketService/WebSocketService";
import { StatusName } from "../../services/api/type";
import PlayCanvasService from "../../services/PlayCanvasService/PlayCanvasService";
import { finishObjectProcessAction } from "../../redux/reducers/ui/actions/actions";

function WebSocketComponent() {
  const dispatch = useAppDispatch();

  const organizationId = MOCK_ORGANIZATION_ID;

  useEffect(() => {
    const socketBaseURL =  process.env.REACT_APP_NODE_ENV_KEY === "development"
      ? process.env.REACT_APP_WEB_SOCKET_URL_DEVELOP
      : process.env.REACT_APP_WEB_SOCKET_URL;;
    const token = process.env.REACT_APP_TOKEN_STUDIO_API;
    const socketUrl = `${socketBaseURL}?token=${token}`;

    WebSocketService.setOrganizationId(organizationId);
    WebSocketService.connect(socketUrl);

    WebSocketService.setEventOnOpen((data) => {
      dispatch(setWsConnected({ ...data }));
    });
    WebSocketService.setEventOnClose((data) => {
      dispatch(setWsConnected({ ...data }));
    });

    WebSocketService.on("pong", (data) => {
      const serverStatus = store.getState().app.serverStatus;
      if (serverStatus !== data.serverStatus)
        dispatch(setServerStatus({ serverStatus: data.serverStatus }));
    });

    WebSocketService.on("image", (data) => {
      const hashRender = store.getState().ui.renderHash;
      const objectProcessData = store.getState().ui.objectProcessData;
      const hashObjectImage = objectProcessData.imageHash;
      const uiProductLoadId = objectProcessData.uiProductLoadId;
      const uiPrevProductId = objectProcessData.prevProductUiId;
      if (data.status === StatusName.SUCCESS) {
        if (hashRender === data.configHash) {
          dispatch(setRenderHash({ hash: "" }));

          dispatch(
            changeShowModal({
              nameModal: "renderLoader",
              stateModal: false,
              otherParams: { img: data.imageUrl },
            })
          );
          dispatch(
            changeShowModal({
              nameModal: "renderPreview",
              stateModal: true,
              otherParams: { img: data.imageUrl },
            })
          );
          dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));
        } else if (hashObjectImage === data.configHash) {
          const [product] = data.config.products;

          if (product && uiProductLoadId) {
            dispatch(
              finishObjectProcessAction({
                finishImage: true,
                productId: uiProductLoadId,
                prevProductId: uiPrevProductId,
                data: {
                  previewImage: data.imageUrl,
                },
              })
            );
          }
        }
      }
    });

    WebSocketService.on("glb", (data) => {
      const objectProcessData = store.getState().ui.objectProcessData;
      const uiProductLoadId = objectProcessData.uiProductLoadId;
      const uiPrevProductId = objectProcessData.prevProductUiId;
      const hash = objectProcessData.renderGLBHash;

      if (data.status === StatusName.SUCCESS) {
        if (hash === data.configHash) {
          const [product] = data.config.products;

          const loadAssetById = (id: string, url: string, replace = false) => {
            if (!replace) {
              return PlayCanvasService.loadAssetById(id, url);
            }

            return PlayCanvasService.replaceAssetById(id, url);
          };

          if (product && uiProductLoadId) {
            loadAssetById(
              uiProductLoadId,
              data.glbUrl,
              !!uiPrevProductId
            ).finally(() => {
              PlayCanvasService.getTransformDataAssetById(uiProductLoadId).then(
                (transform) => {
                  dispatch(
                    finishObjectProcessAction({
                      finishGlb: true,
                      productId: uiProductLoadId,
                      prevProductId: uiPrevProductId,
                      data: {
                        glbData: {
                          url: data.glbUrl,
                          transform: transform,
                        },
                      },
                    })
                  );
                }
              );
            });
          }
        }
      }
    });

    return () => {
      WebSocketService.disconnect();
    };
  }, []);

  return <></>;
}

export default WebSocketComponent;
